import { useEffect, useRef } from "react";
import { useMap, useMapEvents } from "react-leaflet";

export default function DrawMapInteraction({ mode, onAdd, onStrokeStart }) {
    const map = useMap();
    const drawingRef = useRef(false);
    const lastPointRef = useRef(null);

    useEffect(() => {
        if (mode === "draw") {
            map.dragging.disable();
            map.doubleClickZoom.disable();
            map.scrollWheelZoom.disable();
        } else {
            map.dragging.enable();
            map.doubleClickZoom.enable();
            map.scrollWheelZoom.enable();
            drawingRef.current = false;
            lastPointRef.current = null;
        }

        return () => {
            map.dragging.enable();
            map.doubleClickZoom.enable();
            map.scrollWheelZoom.enable();
        };
    }, [map, mode]);

    useMapEvents({
        mousedown(e) {
            if (mode !== "draw") return;
            drawingRef.current = true;
            onStrokeStart?.();
            const point = [e.latlng.lat, e.latlng.lng];
            lastPointRef.current = point;
            onAdd(point);
        },
        mousemove(e) {
            if (mode !== "draw" || !drawingRef.current) return;
            const point = [e.latlng.lat, e.latlng.lng];
            const last = lastPointRef.current;
            if (!last || Math.abs(point[0] - last[0]) > 0.00004 || Math.abs(point[1] - last[1]) > 0.00004) {
                lastPointRef.current = point;
                onAdd(point);
            }
        },
        mouseup() {
            drawingRef.current = false;
            lastPointRef.current = null;
        },
        mouseout() {
            drawingRef.current = false;
            lastPointRef.current = null;
        },
    });

    return null;
}
